    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

        <form  [formGroup]="valForm" (submit)="submitForm($event, valForm.value)">

            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top">
                    <mat-form-field appearance="fill">
                        <mat-label>Banco</mat-label>
                        <input  type="text" required formControlName="bank" matInput   [matAutocomplete]= "auto" />
                        <mat-autocomplete #auto = "matAutocomplete" (optionSelected)="filtrar_banco($event)">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name">
                        {{option.name}}
                        </mat-option>
                    </mat-autocomplete>
                        <mat-hint>Indique el banco</mat-hint>
                        <mat-error *ngIf="valForm.controls['bank'].hasError('required') && (valForm.controls['bank'].dirty || valForm.controls['bank'].touched)">
                                El Banco es <strong>requerido</strong>
                        </mat-error>
                        <mat-error  *ngIf="valForm.controls['bank'].hasError('selected')">Debes seleccionar un banco de la lista</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top">

                    <mat-form-field appearance="fill">
                        <mat-label>Tipo de Cuenta</mat-label>
                        <mat-select formControlName="type"  required>
                            <mat-option *ngFor="let cuenta of cuentas" [value]="cuenta.id">
                            {{cuenta.name}}
                            </mat-option>
                        </mat-select>
                        <mat-hint>Indique el tipo de cuenta</mat-hint>
                        <mat-error *ngIf="valForm.controls['type'].hasError('required') && (valForm.controls['type'].dirty || valForm.controls['type'].touched)">
                            El tipo de cuenta es <strong>requerido</strong>
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>

            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top">
                    <mat-form-field appearance="fill">
                        <mat-label>Nombre y Apellido</mat-label>
                        <input matInput  formControlName="name"  required (input)="formatNameOnChange($event)">
                        <mat-hint>Indique el nombre de la cuenta</mat-hint>
                        <mat-error *ngIf="valForm.controls['name'].hasError('required') && (valForm.controls['name'].dirty || valForm.controls['name'].touched)">
                            El nombre es <strong>requerido</strong>
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top">
                    <mat-form-field appearance="fill">
                        <mat-label>Número de Cuenta</mat-label>
                        <input matInput (input)="formatAccountNumberOnChange($event)" formControlName="number" type="text"  required>
                        <mat-hint>Indique el número de cuenta</mat-hint>
                        <mat-error *ngIf="valForm.controls['number'].hasError('required') && (valForm.controls['number'].dirty || valForm.controls['number'].touched)">
                            El número de cuenta es <strong>requerido</strong>
                        </mat-error>
                        <mat-error *ngIf="valForm.get('number')?.hasError('pattern') && (valForm.get('number')?.dirty || valForm.get('number')?.touched)">
                            El número de cuenta debe ser numerico y contener de 6 a 12 digitos
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>

            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top">
                    <mat-form-field appearance="fill">
                        <mat-label>RUT</mat-label>
                        <input matInput formControlName="rut" [(ngModel)]="run" (input)="formatRutOnChange($event)" required>
                        <mat-hint>Indique el RUT del número de cuenta</mat-hint>
                        <mat-error *ngIf="valForm.controls['rut'].hasError('required') && (valForm.controls['rut'].dirty || valForm.controls['rut'].touched)">
                            El RUT es <strong>requerido</strong>
                        </mat-error>
                        <mat-error *ngIf="valForm.get('rut')?.hasError('pattern') && (valForm.get('rut')?.dirty || valForm.get('rut')?.touched)">
                            El RUT debe ser en formato DDDDDDD-D Ejm: 17983599-8
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 col-top">
                    <mat-form-field appearance="fill">
                        <mat-label>Email</mat-label>
                        <input matInput formControlName="email" (input)="formatEmailOnChange($event)">
                        <mat-hint>Indique el correo electronico de la cuenta</mat-hint>
                        <mat-error *ngIf="valForm.controls['email'].hasError('required') && (valForm.controls['email'].dirty || valForm.controls['email'].touched)">
                            El email es <strong>requerido</strong>
                        </mat-error>
                        <mat-error
                            *ngIf="
                            valForm.get('email')?.hasError('pattern') &&
                            (valForm.get('email')?.dirty || valForm.get('email')?.touched)">
                                El email debe tener un formato válido
                        </mat-error>
                    </mat-form-field>
                </div>

            </div>

            <div class="row">

                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-top">
                    <mat-slide-toggle (toggleChange)="change_toggle_custom($event)" (change)="change_toggle($event)" [disabled]="disableTerceroBtn" color="primary" formControlName="tercero" style="margin-top: 20px;margin-bottom:10px; font-size: 12px;font-size: DM Sans;color:gray;"> Cuenta de terceros</mat-slide-toggle>

                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6 col-top" style="display: flex;" *ngIf="is_tercero" >

                    <input hidden formControlName="file" type="file" id="file" #fileInput (change)="onFileChange($event)"/>
                    
                    <mat-form-field appearance="fill">
                        <input class="no-input" readonly (click)="fileInput.click()" matInput formControlName="placeholderFile" placeholder="Carga el archivo de terceros" [(ngModel)]="placeholder">
                        <mat-error *ngIf="valForm.get('placeholderFile')?.hasError('required') && (valForm.get('placeholderFile')?.dirty || valForm.get('placeholderFile')?.touched)">
                        El archivo de terceros es requerido
                    </mat-error>
                    <mat-icon matSuffix (click)="fileInput.click()" style="cursor: pointer;">attach_file</mat-icon>
                    </mat-form-field>

                </div>

            </div>


                <div style="margin-bottom: 10px;">
                    <button [disabled]="disabledButton" type="button" (click)="submitForm($event, valForm.value)" mat-stroked-button class="primary-button" style="margin-top:20px" color="primary">
                        <span *ngIf="!disabledButton">Guardar</span>
                        <span *ngIf="disabledButton">
                            <i class="fa-solid fa-circle-notch fa-spin-pulse"></i>
                        </span>
                    </button>
                </div>

        </form>

    </div>
